import { FC } from 'react';
import { Tag } from '@servicetitan/design-system';
import { ITenant } from '@servicetitan/marketing-tenant-management-api';
import { TableCellDataProps } from '../../../../common/utils/types';
import { tenantStatusProps } from '../../../utils/tenant-status-props';

export const StatusCell: FC<TableCellDataProps<ITenant>> = ({
    style,
    colSpan,
    className,
    ariaColumnIndex,
    dataItem: { status },
}) => {
    const { displayName, icon, color } = tenantStatusProps[status];

    return (
        <td
            colSpan={colSpan}
            style={{ ...style }}
            className={className}
            aria-colindex={ariaColumnIndex}
        >
            <Tag title="" icon={icon} color={color} subtle compact>
                {displayName}
            </Tag>
        </td>
    );
};
